import { z } from 'zod';
import { EventLoadTypes } from '../events';
import { PRICING_VERSIONS } from './PRICING_VERSIONS';
import { StripeProducts } from './StripeProducts';

const EventStatisticSchema = z.object({
  eventId: z.string(),
  eventName: z.string(),
  billableNow: z.partialRecord(z.enum(StripeProducts), z.number().optional()),
  totalCounts: z.partialRecord(z.enum(StripeProducts), z.number().optional()),
  pricingVersion: z.enum(PRICING_VERSIONS),
  loadCounts: z.record(z.enum(EventLoadTypes), z.number()),
  freeItemCounts: z.partialRecord(z.enum(StripeProducts), z.number()),
});
export type EventStatistic = z.infer<typeof EventStatisticSchema>;

export const EventStatisticsSchema = z.array(EventStatisticSchema);
